<ng-container>
    <div [class.empty]="!inputData"
         class="editable_input"
    >
        <ckeditor (change)="checkChanges()"
                  (focus)="showButtons()"
                  (ready)="onReady($event)"
                  [data]="inputData"
                  [editor]="editorInstance"
                  id="editorId"
        ></ckeditor>
    </div>

    <div *ngIf="openButtons" class="editor-buttons" style="z-index: 1002; position: relative">
        <button (click)="onSave(true)"
                class="button-icon size-l primary-button" 
                data-action="confirmEditor"
         
        >
            <span>{{ 'BUTTON_TEXT.ONLY_SAVE' | translate }}</span>
        </button>
        <button (click)="onCancel()"
                class="button-icon size-l secondary-button" 
                data-action="cancelEditor"
        >
            <span>{{ 'BUTTON_TEXT.CANCEL' | translate }}</span>
        </button>
    </div>
</ng-container>
